/*
 * Copyright (c) 2022 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { Injectable } from '@angular/core';
import { appConstants } from '../data-model/app-constants';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  /**
   * Validator functions
   */
  // sqlInjector
  sqlInjectorCharValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      if (control.value.trim()) {
        let sqlInjectorCharFound = false;
        const regex = new RegExp(appConstants.regEx.sqlInjectionChar);
        sqlInjectorCharFound = regex.test(control.value);
        return sqlInjectorCharFound ? { sqlInjectorChar: { value: control.value } } : null;
      } else {
        return { sqlInjectorChar: { value: control.value } };
      }
    };
  }
  //Validator using the regEx passes
  validatorForRegex(regEx, includes = true): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let testResult = false;
      const regex = new RegExp(regEx);
      testResult = regex.test(control.value);
      return testResult === includes ? { specialChar: { value: control.value } } : null;
    };
  }
}
